import { render, staticRenderFns } from "./UserAccess.vue?vue&type=template&id=7bbe8690&scoped=true"
import script from "./UserAccess.vue?vue&type=script&lang=js"
export * from "./UserAccess.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/_access-management.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./UserAccess.vue?vue&type=style&index=1&id=7bbe8690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbe8690",
  null
  
)

export default component.exports